export const getProxyUrl = (url, fallback = "/default_poster.jpg") => {
  if (!url) return fallback;

  try {
    const encoded = btoa(unescape(encodeURIComponent(url)));
    return `https://raspy-union-7ff8.iconictk2.workers.dev/proxy/${encoded}`;
  } catch (error) {
    console.error("Proxy URL encode error:", error);
    return fallback;
  }
};
